import { render } from "./BreadcrumbProduct.vue?vue&type=template&id=15e10ab4&scoped=true"
import script from "./BreadcrumbProduct.vue?vue&type=script&lang=js"
export * from "./BreadcrumbProduct.vue?vue&type=script&lang=js"

import "./BreadcrumbProduct.vue?vue&type=style&index=0&id=15e10ab4&scoped=true&lang=css"

import exportComponent from "/mnt/data/workspace/risetai/riset.ai-website/Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e10ab4"]])

export default __exports__